import { Fragments } from "requests";

export const getDefaultValues = (exam: Fragments.StoredPhysicalExam) => {
  return {
    generalAppearanceAbnormalStateComments:
      exam?.generalAppearanceAbnormalStateComments || null,
    gastrointestinalAbnormalStateComments:
      exam?.gastrointestinalAbnormalStateComments || null,
    oralCavityAbnormalStateComments:
      exam?.oralCavityAbnormalStateComments || null,
    musculosceletalAbnormalStateComments:
      exam?.musculosceletalAbnormalStateComments || null,
    mucousMembranesAbnormalStateComments:
      exam?.mucousMembranesAbnormalStateComments || null,
    lymphNodesAbnormalStateComments:
      exam?.lymphNodesAbnormalStateComments || null,
    eyesAbnormalStateComments: exam?.eyesAbnormalStateComments || null,
    urogenitalAbnormalStateComments:
      exam?.urogenitalAbnormalStateComments || null,
    earsAbnormalStateComments: exam?.earsAbnormalStateComments || null,
    integumentaryAbnormalStateComments:
      exam?.integumentaryAbnormalStateComments || null,
    cardiovascularAbnormalStateComments:
      exam?.cardiovascularAbnormalStateComments || null,
    nervousSystemAbnormalStateComments:
      exam?.nervousSystemAbnormalStateComments || null,
    respiratoryAbnormalStateComments:
      exam?.respiratoryAbnormalStateComments || null
  };
};
